import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface AccessibilityContextType {
  isToolbarVisible: boolean;
  showToolbar: () => void;
  hideToolbar: () => void;
  toggleToolbar: () => void;
}

const AccessibilityContext = createContext<AccessibilityContextType | undefined>(undefined);

export const AccessibilityProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isToolbarVisible, setIsToolbarVisible] = useState(false);

  const showToolbar = useCallback(() => {
    setIsToolbarVisible(true);
  }, []);

  const hideToolbar = useCallback(() => {
    setIsToolbarVisible(false);
  }, []);

  const toggleToolbar = useCallback(() => {
    setIsToolbarVisible(prev => !prev);
  }, []);

  const value = {
    isToolbarVisible,
    showToolbar,
    hideToolbar,
    toggleToolbar,
  };

  return (
    <AccessibilityContext.Provider value={value}>
      {children}
    </AccessibilityContext.Provider>
  );
};

export const useAccessibility = (): AccessibilityContextType => {
  const context = useContext(AccessibilityContext);
  if (!context) {
    throw new Error('useAccessibility must be used within an AccessibilityProvider');
  }
  return context;
};